var map = {
	"./collection.svg": "6c06",
	"./comment.svg": "03ee",
	"./review.svg": "6a23",
	"./sec-blue.svg": "5ee2",
	"./sec-blue1.svg": "de89",
	"./sec-orange.svg": "2562",
	"./sec-red.svg": "4de1",
	"./sec-white.svg": "8a25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";